<template>
  <div>
    <div class="text-center pb-6">
      <router-link
        :to="{
          name: 'result',
          params: {
            site: questionsConfig.name
          }
        }"
        class="rounded bg-primary p-2 text-white"
      >
        ← Zurück zu den Suchergebnissen
      </router-link>
    </div>
    <div v-if="!loaded" class="flex justify-center">
      <Spinner />
    </div>
    <div v-else class="mx-auto mb-10 sm:px-2 lg:px-4 selected-program">
      <div class="bg-gray-100 shadow overflow-hidden sm:rounded-md p-8">
        <div class="flex justify-end">
          <a
            :href="`/print/${program.id}`"
            target="_blank"
            title="Download"
            class="ui-link matomo_download"
            rel="noopener"
            @click="trackPrintView(program.title)"
          >
            <div class="p-2 text-primary flex">
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                ></path>
              </svg>
              <span class="pl-2">Download PDF</span>
            </div>
          </a>
        </div>
        <h2 class="text-2xl font-bold leading-5 font-medium text-primary pb-4">
          {{ program.title }}
        </h2>
        <div v-html="program.kurzbeschreibung"></div>
        <div>
          <h2 class="text-2xl mt-6">Fördergeber</h2>
          <p v-html="program.foerdergeber.name"></p>
        </div>

        <div>
          <h2 class="text-2xl mt-6">Geltungsbereich</h2>
          <p
            v-if="
              program.foerdergeber.mandant && program.foerdergeber.mandant.label
            "
          >
            {{ program.foerdergeber.name }}
          </p>
          <p v-else-if="program.bundesweit.key === 'FWW_BUNDESWEIT_TRUE'">
            Die Förderung gilt bundesweit.
          </p>
          <div v-else>
            <p>
              Die Förderung gilt für Institutionen in den folgenden
              Bundesländern:
            </p>
            <ul>
              <li v-for="bl in program.bundeslaender" :key="bl.label">
                {{ bl.label }}
              </li>
            </ul>
          </div>
        </div>
        <div>
          <h2 class="text-2xl mt-6">Antragsberechtigte</h2>
          <p v-if="!program.antragsberechtigte">
            Es wurden keine Angaben zu antragsberechtigten Institutionen
            gemacht.
          </p>
          <div v-else v-html="program.antragsberechtigte" />
        </div>

        <h2 class="text-2xl mt-6">Fördergegenstand und -bedingungen</h2>
        <div v-html="program.detailbeschreibung"></div>

        <div>
          <h2 class="text-2xl mt-6">Förderhöhe</h2>
          <table v-if="showSponsoringTable">
            <tbody>
              <tr>
                <th>Förderquote</th>
                <th>Mindestförderhöhe</th>
                <th>Maximale Förderhöhe</th>
              </tr>
              <tr>
                <td>{{ program.foerderquote }} %</td>
                <td>{{ program.max_foerderhoehe }} €</td>
                <td>{{ program.min_foerderhoehe }} €</td>
              </tr>
            </tbody>
          </table>
          <div v-html="program.foerderhoehe_details"></div>
        </div>

        <div v-if="program.kumulierbarkeit">
          <h2 class="text-2xl mt-6">Kumulierbarkeit</h2>
          <div
            v-if="program.kumulierbarkeit.key === 'FWW_KUMULIERBAR_COND'"
            v-html="program.bedingungen_zur_kumulierbarkeit"
          ></div>
          <p v-else-if="program.kumulierbarkeit.key === 'FWW_KUMULIERBAR_TRUE'">
            Die Förderung ist frei kumulierbar mit anderen Förderungen.
          </p>
          <p v-else>
            Die Förderung ist nicht kumulierbar mit anderen Förderungen.
          </p>
        </div>

        <div v-if="program.laufzeit_und_antragsfristen">
          <h2 class="text-2xl mt-6">Laufzeit und Antragsfristen</h2>
          <div v-html="program.laufzeit_und_antragsfristen" />
        </div>

        <div
          v-if="program.antragsstelle_kurzbezeichnung || program.antragstellung"
        >
          <h2 class="text-2xl mt-6">Antragsstellung</h2>
          <div v-if="program.antragsstelle_kurzbezeichnung">
            <p>
              <span class="underline">
                {{ program.antragsstelle_kurzbezeichnung }}
              </span>
            </p>
          </div>
          <div
            v-if="program.antragsstellung"
            v-html="program.antragsstellung"
            class="mt-4"
          ></div>
        </div>

        <div
          v-if="
            Array.isArray(program.weitere_angaben) &&
            program.weitere_angaben.length
          "
        >
          <h2 class="text-2xl mt-6">Weitere Angaben</h2>
          <div v-for="item in program.weitere_angaben" :key="item.title">
            <h3>{{ item.title }}</h3>
            <div v-html="item.content"></div>
          </div>
        </div>

        <div v-if="program.weitere_informationen">
          <h2 class="text-2xl mt-6">Weitere Informationen</h2>
          <div v-html="program.weitere_informationen"></div>
        </div>
      </div>
      <div class="disclaimer rounded shadow bg-gray-100 p-6 mt-8">
        <p>
          Die Klimaschutzberatung Jellinghaus & Dahm GmbH kann trotz größter
          Sorgfalt keine Gewähr für Vollständigkeit und Richtigkeit der
          Information des Förder.Weg.Weisers geben. Bitte prüfen Sie alle
          Förderbedingungen und spezifische technische Anforderungen anhand der
          Förderrichtlinie oder weiterer Informationen des Fördergebers bevor
          Sie einen Antrag stellen.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import Spinner from '@/components/Spinner'

export default {
  name: 'ProgramsSelected',
  components: { Spinner },
  computed: {
    program: get('programs/program'),
    questionsConfig: get('questions/config'),
    selection: get('programs/selection'),
    loaded() {
      return this.$route.params.slug === this.program.slug
    },
    showSponsoringTable() {
      return false
    }
  },
  methods: {
    formattedDate(date) {
      return new Intl.DateTimeFormat('de-DE').format(new Date(date))
    },
    trackPrintView(title) {
      if (!this.$matomo) return
      console.log('for site', this.selection.site)

      this.$matomo.trackEvent('download', 'program', title)
      console.log('this.$matomo', this.$matomo)
    }
  },
  mounted() {
    const appElement = document.getElementById('app')
    if (appElement) {
      appElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  }
}
</script>
